import React, { useState } from 'react';
import styled from 'styled-components';

import CollapsableCard from 'components/ui/CollapsableCard';

import Selector from './Selector';
import { titleize } from 'helpers/Formatter';

import { getTranslatedString } from 'helpers/i18n';

const StyledCard = styled(CollapsableCard)``;

const SelectorMobile = ({
  handleSearch,
  indeterminate,
  onOptionCheckAllChange,
  checkAll,
  options,
  selected,
  verbiage,
  onOptionSelect,
}) => {
  const [cardOpen, setCardOpen] = useState(true);

  return (
    <StyledCard
      cardOpen={cardOpen}
      setCardOpen={setCardOpen}
      title={titleize(verbiage.optionTitle)}
      subtitle={getTranslatedString('landlordPortal.multiselectAdvanced.selected', {
        count: selected.length,
      })}
    >
      <Selector
        handleSearch={handleSearch}
        indeterminate={indeterminate}
        onOptionSelect={onOptionSelect}
        onOptionCheckAllChange={onOptionCheckAllChange}
        checkAll={checkAll}
        options={options}
        selected={selected}
        verbiage={verbiage}
      />
    </StyledCard>
  );
};

export default SelectorMobile;
